<template>
  <ValidationObserver ref="observer" v-slot="{ invalid }">
    <tsny-modal
      :modal-id="modalId"
      :modal-title="'Answer a Question'"
      :submit-button-text="'UPDATE'"
      :submit-disabled="invalid"
      :reset-modal="resetModal"
      :submit-modal="updateQuestion"
      size="lg"
    >
      <b-container fluid>
        <b-row>
          <b-col class="col-2">
            <b-form-group label="Publish">
              <b-form-checkbox v-model="published" switch size="lg" />
            </b-form-group>
          </b-col>
          <b-col class="col-6" v-if="isAdmin">
            <BTextInputValidated
              :data-list="userEmails.tutors"
              v-model="assignedTo"
              label="Assign To"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Courses"
              ><multiselect
                v-model="courses"
                :options="courseOptions"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <BTextInputValidated
              v-model="topic"
              label="Topic"
              placeholder="Writing, Division, GRE Strategies, etc."
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-4">
            <b-form-group label="Question Type">
              <b-form-radio-group
                v-model="questionType"
                :options="questionTypes"
                buttons
              />
            </b-form-group>
          </b-col>
          <b-col v-show="questionType === 'book'">
            <b-row>
              <b-col>
                <b-text-input-validated
                  label="Book"
                  v-model="questionDetails.book"
                /> </b-col
              ><b-col
                ><b-text-input-validated
                  label="Chapter"
                  v-model="questionDetails.chapter"
              /></b-col>
              <b-col
                ><b-text-input-validated
                  label="Page #"
                  v-model="questionDetails.page"
                />
              </b-col>
            </b-row>
          </b-col>
          <b-col v-show="questionType === 'exam'">
            <b-row>
              <b-col>
                <b-text-input-validated
                  label="Exam"
                  v-model="questionDetails.exam"
                /> </b-col
              ><b-col
                ><b-text-input-validated
                  label="Section"
                  v-model="questionDetails.section"
              /></b-col>
              <b-col
                ><b-text-input-validated
                  label="Question #"
                  v-model="questionDetails.number"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <BTextInputValidated
              v-model="question"
              rules="required"
              label="Question"
              placeholder="How do I factor? How do I solve question 3 in Math 1 of practice test x?"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <BTextInputValidated
              v-model="description"
              text-area
              label="Details"
              placeholder="Please describe your question. If it relates to a specific review book, let us know which one and what chapter and page number. If it's about a practice exam question, make sure you indicate the exam, section, and question."
            />
          </b-col> </b-row
        ><b-row>
          <b-col>
            <BTextInputValidated
              v-model="answer"
              text-area
              label="Answer"
              placeholder="Provide your answer to the student's question"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p v-if="questionError" class="tsny_status-text">
              An error occurred updating the question. Please try again in a few
              minutes
            </p>
          </b-col>
        </b-row>
      </b-container>
    </tsny-modal>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import BTextInputValidated from "../FormInputs/BTextInputValidated";
import StoreConstants from "../../store/services/StoreConstants";
import { mapGetters } from "vuex";
import TsnyModal from "../TsnyModal";
import { Multiselect } from "vue-multiselect";
import QuestionBankRestService from "../../services/rest/services/QuestionBankRestService";

export default {
  name: "UpdateQuestionModal",
  components: {
    TsnyModal,
    BTextInputValidated,
    ValidationObserver,
    Multiselect
  },
  props: {
    originalQuestion: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: StoreConstants.GETTERS.IS_ADMIN,
      user: StoreConstants.GETTERS.USER,
      courseObjects: StoreConstants.GETTERS.COURSE_OBJECTS,
      userEmails: StoreConstants.GETTERS.USER_EMAILS
    }),
    courseOptions() {
      return ["General", ...this.courseObjects.map(course => course._id)];
    }
  },
  data() {
    return {
      modalId: "updateQuestionModal",
      questionTypes: [
        { text: "General", value: "general" },
        { text: "Book", value: "book" },
        { text: "Exam", value: "exam" }
      ],
      id: null,
      courses: [],
      topic: null,
      question: null,
      description: null,
      answer: null,
      questionType: null,
      questionDetails: {},
      published: null,
      assignedTo: null,
      questionError: null
    };
  },
  methods: {
    resetModal() {
      this.questionError = null;

      let question = this.originalQuestion;

      this.courses = question.courses;
      this.id = question._id;
      this.questionType = question.questionType;
      this.questionDetails = question.questionDetails || {};
      this.question = question.question;
      this.topic = question.topic;
      this.description = question.description;
      this.answer = question.answer;
      this.published = question.published;
      this.assignedTo = question.assignedTo;
    },
    async updateQuestion(bvModalEvt) {
      bvModalEvt.preventDefault();
      let $comp = this,
        isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      $comp.questionError = false;

      try {
        await QuestionBankRestService.updateQuestion({
          id: this.id,
          courses: this.courses,
          questionType: this.questionType,
          questionDetails: this.questionDetails,
          topic: this.topic,
          question: this.question,
          description: this.description,
          answer: this.answer,
          assignedTo: this.assignedTo,
          published: this.published
        });
        $comp.$bvModal.hide($comp.modalId);
      } catch (err) {
        console.log(err);
        $comp.questionError = true;
      }
    }
  }
};
</script>

<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css" />

<style scoped />
